import _isEmpty from 'lodash/isEmpty';
import React, { Component } from 'react';
import { Checkbox, Form, Input, Button } from 'antd';
import Cookies from 'js-cookie';
import styles from './styles.scss';

class SignUpForm extends Component {
  onFinish = (values) => {
    const { product } = this.props;
    const utmSource = Cookies.get('utmSource');
    let promo = Cookies.get('promo');

    if (_isEmpty(promo) && /^r-(\w+)$/i.test(utmSource)) {
      promo = utmSource;
    }

    this.props.signUp({
      variables: {
        input: {
          user: {
            email: values.email,
            password: values.password,
          },
          source: utmSource,
          promo,
          activeProductSlug: product.slug,
        },
      },
    });
  };

  render() {
    const { loading } = this.props;

    return (
      <Form
        onFinish={this.onFinish}
        className={styles.form}
        initialValues={{ terms: false }}
      >
        <Form.Item
          name="email"
          rules={[{ type: 'email', required: true, message: 'Please input your email' }]}
        >
          <Input
            data-aaa="signUpEmail"
            autoComplete="username"
            prefix={<i className="fal fa-user" />}
            placeholder="Email"
          />
        </Form.Item>
        <Form.Item
          name="password"
          rules={[{ required: true, message: 'Please input a password' }]}
        >
          <Input
            data-aaa="signUpPassword"
            autoComplete="new-password"
            prefix={<i className="fal fa-lock" />}
            type="password"
            placeholder="Password"
          />
        </Form.Item>
        <Form.Item
          className={styles.terms}
          name="terms"
          valuePropName="checked"
          rules={[
            {
              required: true,
              transform: (value) => value || undefined,
              type: 'boolean',
              message: 'You must agree to the T&C',
            },
          ]}
        >
          <Checkbox data-aaa="signUpTerms">
            I agree to the{' '}
            <a
              href="https://www.iubenda.com/terms-and-conditions/18707085"
              target="_blank"
              rel="noopener noreferrer"
            >
              Terms and Conditions
            </a>
          </Checkbox>
        </Form.Item>
        <Form.Item>
          <Button
            data-aaa="signUpSubmit"
            type="primary"
            htmlType="submit"
            block
            loading={loading}
          >
            Sign up for free and read more
          </Button>
        </Form.Item>
      </Form>
    );
  }
}

export default SignUpForm;
